/* mg-luxe 26.10 – the script part of snippets/mg-luxe-2510.liquid, moved to a cached file loaded with defer (page speed) */
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hero = document.querySelector('main .hero');
    /* Latin-only lines (MOZES GALLERY) are split into word boxes by the word animation; in a right-to-left page those boxes run backwards, so such lines read left to right. */
    document.querySelectorAll('main .text-block p, main .text-block h1, main .text-block h2, main .text-block h3').forEach(function (p) {
      var t = p.textContent.trim();
      if (t && !/[֐-׿؀-ۿ]/.test(t) && /[A-Za-z]/.test(t)) { p.setAttribute('dir', 'ltr'); p.style.unicodeBidi = 'isolate'; }
    });
    var isHome =document.body.classList.contains('template-index') || /__hero$/.test((hero && hero.closest('[id^="shopify-section"]') || {}).id || '') && location.pathname.replace(/^\/(en|ar|ru)\b/, '') === '/';
    if (hero && hero.querySelector('.hero__media') && isHome) hero.classList.add('mg-hero-film');
    if (isHome) document.body.classList.add('mg-wash');

    /* 2. the hero film drifts slower than the page (desktop) */
    if (hero && isHome && !reduce && window.matchMedia('(min-width: 750px)').matches) {
      var media = hero.querySelector('.hero__media-wrapper--desktop');
      var copy = hero.querySelector('.hero__content-wrapper');
      var tick = false;
      var drift = function () {
        tick = false;
        var r = hero.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var p = Math.min(1, Math.max(0, -r.top / r.height));
        if (media) media.style.transform = 'translate3d(0,' + (p * r.height * 0.22).toFixed(1) + 'px,0) scale(' + (1 + p * 0.04).toFixed(4) + ')';
        if (copy) { copy.style.opacity = (1 - p * 1.4).toFixed(3); copy.style.transform = 'translate3d(0,' + (p * -40).toFixed(1) + 'px,0)'; }
      };
      if (media) { media.style.willChange = 'transform'; hero.querySelector('.hero__media-grid').style.overflow = 'hidden'; }
      /* The page may scroll inside a container rather than the window, so listen in the capture phase. */
      document.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(drift); } }, { passive: true, capture: true });
    }

    /* 3. product cards lean toward the pointer */
    if (!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var bind = function (card) {
        if (card.getAttribute('data-mg-tilt')) return;
        card.setAttribute('data-mg-tilt', '1');
        card.classList.add('mg-tilt');
        card.addEventListener('pointermove', function (e) {
          var b = card.getBoundingClientRect();
          var x = (e.clientX - b.left) / b.width - 0.5, y = (e.clientY - b.top) / b.height - 0.5;
          card.classList.add('mg-tilt--on');
          card.style.transform = 'perspective(900px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg) translateY(-3px)';
        });
        card.addEventListener('pointerleave', function () { card.classList.remove('mg-tilt--on'); card.style.transform = ''; });
      };
      var scan = function () { document.querySelectorAll('product-card, .product-card').forEach(bind); };
      scan();
      /* Cards added later (filters, load more, quick view) are picked up, at most once per quarter second. */
      var pending = 0;
      new MutationObserver(function () { if (!pending) pending = setTimeout(function () { pending = 0; scan(); }, 250); }).observe(document.body, { childList: true, subtree: true });
    }

    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    /* 6a. the landing page applies \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035 for ad visitors; a creator's visitor gets the creator's code back right away */
    try {
      var saved = JSON.parse(localStorage.getItem('mgCreatorCode') || 'null');
      if (saved && saved.c && Date.now() - saved.t < 30 * 864e5 && /\/pages\/moissanite/.test(location.pathname)) {
        var tries = 0, back = false;
        var guard = setInterval(function () {
          if (++tries > 16) return clearInterval(guard);
          if (!back && /(^|;\s*)discount_code=\u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035/i.test(document.cookie)) {
            back = true;
            fetch('/discount/' + encodeURIComponent(saved.c) + '?redirect=%2Fcart.js', { credentials: 'same-origin' }).catch(function () {});
          }
        }, 500);
      }
    } catch (e) {}

    /* 6b. a slow ribbon of the store's promises under the home hero */
    if (isHome && hero && !document.querySelector('.mg-marquee')) {
      var items = ['מואסנייט עם תעודה לכל אבן', 'כסף 925', 'אחריות לשנה', '14 יום להחזרה', 'משלוח חינם מעל 299 ₪', 'אריזת מתנה'];
      var band = document.createElement('div');
      band.className = 'mg-marquee';
      band.setAttribute('aria-label', items.join(' · '));
      var row = '';
      for (var r = 0; r < 4; r++) items.forEach(function (t) { row += '<span class="mg-marquee__item" aria-hidden="true">' + t + '</span>'; });
      band.innerHTML = '<div class="mg-marquee__track">' + row + '</div>';
      var sec = hero.closest('[id^="shopify-section"]');
      if (sec) sec.insertAdjacentElement('afterend', band);
    }

    /* 6c. a soft gold light follows the pointer in dark mode (desktop) */
    if (fine && !reduce) {
      var spot = document.createElement('div');
      spot.className = 'mg-spot';
      spot.setAttribute('aria-hidden', 'true');
      document.body.appendChild(spot);
      var sx = 0, sy = 0, sTick = false;
      addEventListener('pointermove', function (e) {
        sx = e.clientX; sy = e.clientY;
        if (!sTick) { sTick = true; requestAnimationFrame(function () { sTick = false; spot.style.setProperty('--mgx', sx + 'px'); spot.style.setProperty('--mgy', sy + 'px'); spot.classList.add('is-on'); }); }
      }, { passive: true });
      document.addEventListener('pointerleave', function () { spot.classList.remove('is-on'); });

      /* 6d. the main buttons lean a few pixels toward the pointer */
      document.addEventListener('pointermove', function (e) {
        var b = e.target.closest && e.target.closest('.button-custom, .button:not(.button--tertiary), button[name="add"]');
        if (!b) return;
        var q = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (((e.clientX - q.left) / q.width - 0.5) * 6).toFixed(1) + 'px,' + (((e.clientY - q.top) / q.height - 0.5) * 5).toFixed(1) + 'px)';
        if (!b.mgMag) { b.mgMag = 1; b.addEventListener('pointerleave', function () { b.style.transform = ''; }); }
      }, { passive: true });
    }

    /* 6e. back to top, with a gold ring that fills as the page scrolls */
    var top = document.createElement('button');
    top.type = 'button';
    top.className = 'mg-top';
    top.setAttribute('aria-label', 'חזרה לראש העמוד');
    top.innerHTML = '<svg viewBox="0 0 46 46" aria-hidden="true"><circle class="mg-top__bg" cx="23" cy="23" r="20"/><circle class="mg-top__ring" cx="23" cy="23" r="20"/><path class="mg-top__arrow" d="M17 25l6-6 6 6"/></svg>';
    document.body.appendChild(top);
    var ring = top.querySelector('.mg-top__ring'), tTick = false, box = null;
    /* The page may scroll inside a tall wrapper instead of the window; remember whichever one really scrolls the page. */
    var pageBox = function (el) { return el && el.nodeType === 1 && el.clientHeight > innerHeight * 0.6 && el.scrollHeight > el.clientHeight + 200 ? el : null; };
    var onScroll = function () {
      tTick = false;
      var s = box || document.scrollingElement || document.documentElement;
      var y = box ? box.scrollTop : (window.scrollY || s.scrollTop), max = box ? box.scrollHeight - box.clientHeight : s.scrollHeight - innerHeight;
      top.classList.toggle('is-on', y > 700);
      ring.style.strokeDashoffset = (125.7 * (1 - Math.min(1, max > 0 ? y / max : 0))).toFixed(1);
    };
    document.addEventListener('scroll', function (e) { box = pageBox(e.target) || box; if (!tTick) { tTick = true; requestAnimationFrame(onScroll); } }, { passive: true, capture: true });
    top.addEventListener('click', function () { (box || window).scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

    /* 6f. a small burst of gold light when something goes into the bag */
    if (!reduce) {
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('button[name="add"], .add-to-cart-button, [data-mg-quick-add], .quick-add__submit');
        if (!b || !document.body.animate) return;
        var q = b.getBoundingClientRect(), cx = e.clientX || q.left + q.width / 2, cy = e.clientY || q.top + q.height / 2;
        for (var i = 0; i < 14; i++) {
          var p = document.createElement('i');
          p.className = 'mg-spark';
          p.style.left = cx + 'px'; p.style.top = cy + 'px';
          document.body.appendChild(p);
          var a = (Math.PI * 2 * i) / 14 + Math.random() * 0.4, d = 34 + Math.random() * 38;
          p.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + (Math.cos(a) * d).toFixed(1) + 'px,' + (Math.sin(a) * d - 12).toFixed(1) + 'px) scale(.3)', opacity: 0 }], { duration: 650 + Math.random() * 250, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () { this.effect.target.remove(); };
        }
      }, true);
    }

    /* 6i. the moissanite type links get drawn gold icons instead of emoji that did not match (owner's request) */
    var ICONS = {
      'טבעות': '<circle cx="12" cy="15.5" r="5.5"/><path d="M9.2 5.8h5.6L12 9.6zM9.2 5.8L10.4 4h3.2l1.2 1.8"/>',
      'עגילים': '<path d="M12 3.5a2.5 2.5 0 0 1 2.5 2.5c0 1.6-2.5 2.2-2.5 4"/><circle cx="12" cy="11.6" r="1.4"/><path d="M12 13v1.6M12 15l-2.6 3L12 21l2.6-3z"/>',
      'שרשראות': '<path d="M4.5 4c.6 6 3.6 9.5 7.5 9.5S18.9 10 19.5 4"/><path d="M12 13.5v1.6M12 15.2l-2.3 2.6 2.3 2.8 2.3-2.8z"/>',
      'צמידים': '<ellipse cx="12" cy="12" rx="8.5" ry="5.5"/><circle cx="12" cy="17.5" r="1.3"/><circle cx="7.6" cy="16.7" r="1.1"/><circle cx="16.4" cy="16.7" r="1.1"/>',
      'סטים': '<rect x="4" y="9.5" width="16" height="10.5" rx="1.5"/><path d="M3.5 9.5h17M12 9.5V20M12 9.5c-1.4-2.8-5-3.4-5-1.2 0 1.2 5 1.2 5 1.2zm0 0c1.4-2.8 5-3.4 5-1.2 0 1.2-5 1.2-5 1.2z"/>',
      'מה זה': '<path d="M6.5 4h11L21 9l-9 11L3 9z"/><path d="M3 9h18M9.5 4L12 9l2.5-5M12 9v11"/>'
    };
    document.querySelectorAll('.mg-motypes a').forEach(function (a) {
      if (a.querySelector('.mg-ti')) return;
      var label = a.textContent.replace(/^[^֐-׿A-Za-z]+/, '').trim();
      var key = Object.keys(ICONS).filter(function (k) { return label.indexOf(k) === 0; })[0];
      if (!key) return;
      a.innerHTML = '<svg class="mg-ti" viewBox="0 0 24 24" aria-hidden="true">' + ICONS[key] + '</svg><span>' + label + '</span>';
    });

    /* 6j–6n run inside a guard: a failure here must never stop 6g, which hides the welcome code */
    try {
    /* 6j. gold dust drifts up over the home film; it stops when the film is off screen or the tab is hidden */
    if (isHome && hero && !reduce && window.IntersectionObserver) {
      var dGrid = hero.querySelector('.hero__media-grid') || hero;
      var dCv = document.createElement('canvas');
      dCv.className = 'mg-dust';
      dCv.setAttribute('aria-hidden', 'true');
      hero.appendChild(dCv);
      var dCx = dCv.getContext('2d'), dDpr = Math.min(2, window.devicePixelRatio || 1), dW = 0, dH = 0, dMotes = [], dOn = false, dRaf = 0;
      var dSize = function () {
        var hb = hero.getBoundingClientRect(), gb = dGrid.getBoundingClientRect();
        dW = gb.width; dH = gb.height;
        dCv.style.top = (gb.top - hb.top) + 'px'; dCv.style.left = (gb.left - hb.left) + 'px';
        dCv.style.width = dW + 'px'; dCv.style.height = dH + 'px';
        dCv.width = Math.round(dW * dDpr); dCv.height = Math.round(dH * dDpr);
        dCx.setTransform(dDpr, 0, 0, dDpr, 0, 0);
      };
      var dMote = function (y) { return { x: Math.random() * dW, y: y == null ? Math.random() * dH : y, r: 0.6 + Math.random() * 1.6, v: 0.12 + Math.random() * 0.35, d: Math.random() * 6.28, t: Math.random() * 6.28 }; };
      dSize();
      for (var dq = innerWidth < 750 ? 18 : 34; dq > 0; dq--) dMotes.push(dMote());
      var dDraw = function () {
        dCx.clearRect(0, 0, dW, dH);
        for (var i = 0; i < dMotes.length; i++) {
          var m = dMotes[i];
          m.y -= m.v; m.d += 0.01; m.t += 0.045; m.x += Math.sin(m.d) * 0.25;
          if (m.y < -6) m = dMotes[i] = dMote(dH + 6);
          var a = 0.25 + 0.55 * Math.abs(Math.sin(m.t)), g = dCx.createRadialGradient(m.x, m.y, 0, m.x, m.y, m.r * 3);
          g.addColorStop(0, 'rgba(255,236,190,' + a.toFixed(2) + ')');
          g.addColorStop(1, 'rgba(226,192,126,0)');
          dCx.fillStyle = g;
          dCx.beginPath(); dCx.arc(m.x, m.y, m.r * 3, 0, 6.283); dCx.fill();
        }
        dRaf = requestAnimationFrame(dDraw);
      };
      var dGo = function (on) { if (on && !dOn) { dOn = true; dDraw(); } else if (!on && dOn) { dOn = false; cancelAnimationFrame(dRaf); } };
      var dSeen = true;
      new IntersectionObserver(function (en) { dSeen = en[0].isIntersecting; dGo(dSeen && !document.hidden); }).observe(hero);
      document.addEventListener('visibilitychange', function () { dGo(dSeen && !document.hidden); });
      addEventListener('resize', dSize, { passive: true });
    }

    /* 6k. live countdowns to the end of the Black Friday and Hanukkah sale (Saturday 12.12, extended from 27.11 on 26.10), as day / hour / minute / second boxes:
       under the home film's buttons, on the deals band, above the price on product pages, on the moissanite landing page
       and in the sign-up box (6r). One timer feeds them all, and each ticks inside a shadow root, so it never wakes the
       page's text observers. */
    var cdEnd = new Date('2026-12-12T23:59:59+02:00').getTime();
    var cdHosts = [];
    var cdMake = function (at, how, cls, lead) {
      if (!at || Date.now() >= cdEnd || !document.body.attachShadow) return null;
      var host = document.createElement('span');
      host.className = 'mg-cdx' + (cls ? ' ' + cls : '');
      host.setAttribute('role', 'timer');
      at.insertAdjacentElement(how, host);
      var root = host.attachShadow({ mode: 'open' });
      root.innerHTML = '<style>.l{font-size:13px;margin-inline-end:4px}.u{display:inline-flex;flex-direction:column;align-items:center;min-width:34px;padding:4px 6px;border-radius:9px;background:var(--mgcd-bg);border:1px solid var(--mgcd-bd)}b{font-weight:700;font-size:15px;line-height:1.15;font-variant-numeric:tabular-nums;color:var(--mgcd-num)}i{font-style:normal;font-size:10px;opacity:.75}' +
        ':host(.mg-cdx--pdp) .l,:host(.mg-cdx--pop) .l,:host(.mg-cdx--land) .l{width:100%;margin:0 0 2px}:host(.mg-cdx--pop) .l,:host(.mg-cdx--land) .l{text-align:center}@media (max-width:749px){.l{width:100%;text-align:center;margin:0 0 2px}:host(.mg-cdx--pdp) .l{text-align:start}}</style>' +
        '<span class="l">' + lead + '</span><span class="u"><b></b><i>ימים</i></span><span class="u"><b></b><i>שעות</i></span><span class="u"><b></b><i>דקות</i></span><span class="u"><b></b><i>שניות</i></span>';
      cdHosts.push({ host: host, n: root.querySelectorAll('b') });
      cdTick();
      return host;
    };
    var cdTimer = 0;
    var cdTick = function () {
      var left = Math.max(0, Math.floor((cdEnd - Date.now()) / 1000));
      var two = function (v) { return (v < 10 ? '0' : '') + v; };
      cdHosts.forEach(function (x) {
        if (!left) { x.host.remove(); return; }
        var v = [Math.floor(left / 86400), two(Math.floor(left % 86400 / 3600)), two(Math.floor(left % 3600 / 60)), two(left % 60)];
        for (var i = 0; i < 4; i++) if (x.n[i].textContent !== String(v[i])) x.n[i].textContent = v[i];
      });
      if (!cdTimer && cdHosts.length) cdTimer = setInterval(cdTick, 1000);
    };
    if (isHome && hero && !document.querySelector('.mg-cdx--hero')) {
      var cdBtns = hero.querySelectorAll('a.button-custom');
      if (cdBtns.length) {
        /* the buttons sit straight in the copy column: the countdown goes right after the last one (or after their own group, if they have one) */
        var cdLast = cdBtns[cdBtns.length - 1], cdP = cdLast.parentElement;
        cdMake([].every.call(cdP.children, function (k) { return k.matches('a.button-custom'); }) ? cdP : cdLast, 'afterend', 'mg-cdx--hero', '⏳ מבצע בלאק פריידיי וחנוכה נגמר בעוד');
      }
    }
    var cdDeals = isHome && document.querySelector('[id$="__deals"] .section, [id$="__deals"]');
    if (cdDeals && !cdDeals.querySelector('.mg-cdx')) {
      var cdRow = document.createElement('div');
      cdRow.className = 'mg-cdx-row';
      cdDeals.insertAdjacentElement('afterbegin', cdRow);
      cdMake(cdRow, 'afterbegin', '', '⏳ ההנחות האלה נגמרות בעוד');
    }
    var cdPrice = /\/products\//.test(location.pathname) && document.querySelector('main .product-details product-price, main product-price');
    if (cdPrice && !document.querySelector('.mg-cdx--pdp')) cdMake(cdPrice, 'beforebegin', 'mg-cdx--pdp', '🖤 בלאק פריידיי וחנוכה נגמר בעוד');
    var cdLand = document.querySelector('.mgfl .mgfl-total');
    if (cdLand && !document.querySelector('.mg-cdx--land')) cdMake(cdLand, 'afterend', 'mg-cdx--land', '⏳ נגמר בעוד');

    /* 6l. a gold ring opens where a button is pressed */
    if (!reduce) {
      document.addEventListener('pointerdown', function (e) {
        var b = e.target.closest && e.target.closest('.button-custom, .button, button[name="add"], .mg-motypes a, .mg-heart, .mg-wfab');
        if (!b || !document.body.animate) return;
        var rg = document.createElement('i');
        rg.className = 'mg-ring';
        rg.style.left = e.clientX + 'px'; rg.style.top = e.clientY + 'px';
        document.body.appendChild(rg);
        rg.animate([{ transform: 'translate(-50%,-50%) scale(.15)', opacity: 0.95 }, { transform: 'translate(-50%,-50%) scale(1)', opacity: 0 }], { duration: 620, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () { rg.remove(); };
      }, { passive: true });
    }

    /* 6m. favourites, kept in this browser: a heart on every product card and on the product page, and a gold heart button that lists them */
    var wGet = function () { try { return JSON.parse(localStorage.getItem('mgWish') || '[]'); } catch (e) { return []; } };
    var wSet = function (a) { try { localStorage.setItem('mgWish', JSON.stringify(a.slice(0, 40))); } catch (e) {} };
    var handleOf = function (href) { var m = String(href || '').match(/\/products\/([^/?#]+)/); try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return m ? m[1] : ''; } };
    var money = function (c) { var v = c / 100; return (v % 1 ? v.toFixed(2) : String(v)) + ' ₪'; };
    var imgOf = function (p) { var s = p.featured_image || ''; if (s.indexOf('//') === 0) s = 'https:' + s; return s ? s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=300' : ''; };
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pCache = {};
    var pGet = function (h) { return (pCache[h] = pCache[h] || fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })); };
    var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.3-4.4-7.3-10A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.3 2.7c0 5.6-7.3 10-7.3 10z"/></svg>';
    var wFab = document.createElement('button');
    wFab.type = 'button';
    wFab.className = 'mg-wfab';
    wFab.setAttribute('aria-label', 'המועדפים שלי');
    wFab.innerHTML = HEART + '<span class="mg-wfab__n"></span>';
    document.body.appendChild(wFab);
    var wSync = function () {
      var list = wGet();
      document.querySelectorAll('.mg-heart').forEach(function (b) {
        var on = list.indexOf(b.getAttribute('data-h')) !== -1;
        if (b.classList.contains('is-on') !== on) { b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }
      });
      wFab.classList.toggle('is-on', list.length > 0);
      var n = wFab.querySelector('.mg-wfab__n'), t = list.length ? String(list.length) : '';
      if (n.textContent !== t) n.textContent = t;
    };
    var wToggle = function (h, btn) {
      var list = wGet(), i = list.indexOf(h);
      if (i === -1) list.unshift(h); else list.splice(i, 1);
      wSet(list);
      wSync();
      if (btn && i === -1 && btn.animate && !reduce) btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
    };
    var heartBtn = function (h, extra) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mg-heart' + (extra ? ' ' + extra : '');
      b.setAttribute('data-h', h);
      b.setAttribute('aria-label', 'שמירה למועדפים');
      b.innerHTML = HEART;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); wToggle(h, b); });
      return b;
    };
    var wCards = function () {
      document.querySelectorAll('product-card').forEach(function (c) {
        if (c.mgHeart) return;
        var a = c.querySelector('a.product-card__link') || c.querySelector('a[href*="/products/"]');
        var h = a && handleOf(a.getAttribute('href'));
        var g = c.querySelector('.card-gallery');
        if (!h || !g) return;
        c.mgHeart = 1;
        g.appendChild(heartBtn(h));
      });
      wSync();
    };
    wCards();
    var wPend = 0;
    new MutationObserver(function () { if (!wPend) wPend = setTimeout(function () { wPend = 0; wCards(); }, 400); }).observe(document.body, { childList: true, subtree: true });
    var wPanel = null;
    var wFill = function () {
      var box = wPanel.querySelector('.mg-wl__list'), list = wGet();
      if (!list.length) { box.innerHTML = '<p class="mg-wl__empty">עוד לא שמרת תכשיטים. לחצו על הלב שבתמונה של תכשיט, והוא יחכה לכם כאן.</p>'; return; }
      box.innerHTML = '';
      list.forEach(function (h) {
        var it = document.createElement('div');
        it.className = 'mg-wl__it';
        box.appendChild(it);
        pGet(h).then(function (p) {
          if (!p) { it.remove(); return; }
          var img = imgOf(p);
          it.innerHTML = '<a href="' + ROOT + 'products/' + encodeURIComponent(h) + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '<span><b></b><em>' + money(p.price) + '</em></span></a><button type="button" aria-label="הסרה מהמועדפים">×</button>';
          it.querySelector('b').textContent = p.title;
          it.querySelector('button').addEventListener('click', function () { wToggle(h); it.remove(); if (!wGet().length) wFill(); });
        });
      });
    };
    wFab.addEventListener('click', function () {
      if (!wPanel) {
        wPanel = document.createElement('div');
        wPanel.className = 'mg-wl';
        wPanel.setAttribute('role', 'dialog');
        wPanel.setAttribute('aria-modal', 'true');
        wPanel.setAttribute('aria-label', 'המועדפים שלי');
        wPanel.innerHTML = '<div class="mg-wl__bg" data-x></div><div class="mg-wl__box"><div class="mg-wl__head"><b>♡ המועדפים שלי</b><button type="button" class="mg-wl__x" data-x aria-label="סגירה">×</button></div><div class="mg-wl__list"></div></div>';
        document.body.appendChild(wPanel);
        wPanel.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) wPanel.classList.remove('is-open'); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wPanel) wPanel.classList.remove('is-open'); });
      }
      wFill();
      requestAnimationFrame(function () { wPanel.classList.add('is-open'); });
    });

    /* 6n. product pages: a save-to-favourites button under the title, and the jewels this visitor looked at before */
    var pHandle = /\/products\//.test(location.pathname) ? handleOf(location.pathname) : '';
    if (pHandle) {
      var seen = [];
      try { seen = JSON.parse(localStorage.getItem('mgSeen') || '[]'); } catch (e) {}
      var before = seen.filter(function (h) { return h !== pHandle; });
      try { localStorage.setItem('mgSeen', JSON.stringify([pHandle].concat(before).slice(0, 12))); } catch (e) {}
      var pTitle = document.querySelector('main h1');
      if (pTitle && !document.querySelector('.mg-heart--pdp')) {
        var pHeart = heartBtn(pHandle, 'mg-heart--pdp');
        pHeart.insertAdjacentHTML('beforeend', '<span>שמירה למועדפים</span>');
        pTitle.insertAdjacentElement('afterend', pHeart);
        wSync();
      }
      before = before.slice(0, 8);
      var firstSec = document.querySelector('main .shopify-section');
      if (before.length && firstSec && !document.querySelector('.mg-seen')) {
        var sStrip = document.createElement('section');
        sStrip.className = 'mg-seen';
        sStrip.setAttribute('aria-label', 'צפית לאחרונה');
        sStrip.innerHTML = '<h3 class="mg-seen__t">צפית לאחרונה</h3><div class="mg-seen__row"></div>';
        firstSec.insertAdjacentElement('afterend', sStrip);
        var sRow = sStrip.querySelector('.mg-seen__row');
        before.forEach(function (h) {
          var a = document.createElement('a');
          a.className = 'mg-seen__it';
          a.href = ROOT + 'products/' + encodeURIComponent(h);
          sRow.appendChild(a);
          pGet(h).then(function (p) {
            if (!p) { a.remove(); if (!sRow.children.length) sStrip.remove(); return; }
            var img = imgOf(p);
            a.innerHTML = (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '<b></b><em>' + money(p.price) + '</em>';
            a.querySelector('b').textContent = p.title;
          });
        });
      }
    }

    /* 6o. the server picked jewellery that completes this piece: it takes the place of the theme's random recommendations */
    var cTpl = document.getElementById('mgComplete');
    if (cTpl && !document.querySelector('.mg-comp')) {
      var cRec = document.querySelector('product-recommendations');
      var cSec = cRec && (cRec.closest('.shopify-section') || cRec);
      var cNode = cTpl.content.firstElementChild.cloneNode(true);
      if (cSec) { cSec.insertAdjacentElement('beforebegin', cNode); cSec.style.display = 'none'; }
      else {
        var cAfter = document.querySelector('.mg-seen') || document.querySelector('main .shopify-section');
        if (cAfter) cAfter.insertAdjacentElement('afterend', cNode);
      }
    }
    /* 6p. "איך מדברים איתכם?" offers WhatsApp too, between the site chat and the email (owner's request) */
    var waRe = /בצ['׳]אט באתר או במייל/;
    document.querySelectorAll('main p').forEach(function (p) {
      if (p.querySelector('.mg-wa-link') || !waRe.test(p.textContent)) return;
      var tw = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null), n;
      while ((n = tw.nextNode())) {
        if (!waRe.test(n.nodeValue)) continue;
        var bits = n.nodeValue.split(waRe);
        var wa = document.createElement('a');
        wa.className = 'mg-wa-link';
        wa.href = 'https://wa.me/972549200495';
        wa.target = '_blank';
        wa.rel = 'noopener';
        wa.textContent = 'בוואטסאפ';
        var frag = document.createDocumentFragment();
        frag.appendChild(document.createTextNode(bits[0] + 'בצ\'אט באתר, '));
        frag.appendChild(wa);
        frag.appendChild(document.createTextNode(' או במייל' + (bits[1] || '')));
        n.parentNode.replaceChild(frag, n);
        break;
      }
    });
    /* 6r. the sign-up box: the round logo and the name on top, the deadline line, a gold tick once the email looks right,
       and a burst of gold sparks when the box comes back showing the code */
    var rPop = document.getElementById('mgPop');
    if (rPop && !rPop.querySelector('.mg-pop__logo')) {
      var rC = rPop.querySelector('.mg-pop__c');
      if (rC) {
        rC.insertAdjacentHTML('afterbegin', '<img class="mg-pop__logo" src="https://mozesgallery.com/cdn/shop/files/mozes-logo-ring-round-640.png?width=160" alt="Mozes Gallery" width="62" height="62"><p class="mg-pop__brand">MOZES GALLERY</p>');
        var rPerks = rC.querySelector('.mg-pop__perks');
        if (rPerks) cdMake(rPerks, 'afterend', 'mg-cdx--pop', '⏳ ההטבה נגמרת בעוד');
      }
      var rIn = rPop.querySelector('input[type=email]');
      if (rIn) rIn.addEventListener('input', function () { rIn.classList.toggle('is-ok', /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(rIn.value.trim())); });
      if (rPop.querySelector('[data-mg-success]') && !reduce && document.body.animate) {
        setTimeout(function () {
          if (rPop.hidden) return;
          var rAt = (rPop.querySelector('.mg-pop__code') || rPop.querySelector('.mg-pop__c')).getBoundingClientRect();
          for (var i = 0; i < 22; i++) {
            var sp = document.createElement('i');
            sp.className = 'mg-spark';
            sp.style.left = (rAt.left + rAt.width / 2) + 'px'; sp.style.top = (rAt.top + rAt.height / 2) + 'px'; sp.style.zIndex = '1001';
            document.body.appendChild(sp);
            var ang = Math.PI * 2 * i / 22, dist = 50 + Math.random() * 60;
            sp.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + (Math.cos(ang) * dist).toFixed(1) + 'px,' + (Math.sin(ang) * dist).toFixed(1) + 'px) scale(.3)', opacity: 0 }], { duration: 900 + Math.random() * 300, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () { this.effect.target.remove(); };
          }
        }, 700);
      }
    }

    /* 6q. the sign-up box also subscribes the email straight to Klaviyo's "Email List" (Y884Lp): the Shopify sync never
       passed the popup's sign-ups on, so the welcome flow never ran. The offer rides on the profile (mg_offer), so a
       creator's visitor gets the \u0056\u0049\u0050\u0031\u0030 welcome and everyone else the \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035 one. */
    var kForm = document.querySelector('#mgPop form');
    if (kForm && window.fetch && !kForm.mgKl) {
      kForm.mgKl = 1;
      kForm.addEventListener('submit', function () {
        var em = ((kForm.querySelector('input[type=email]') || {}).value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) return;
        var kc = null;
        try { kc = JSON.parse(localStorage.getItem('mgCreatorCode') || 'null'); } catch (e) {}
        var vipOn = document.documentElement.classList.contains('mg-creator') && kc && kc.c;
        var props = vipOn ? { mg_offer: '\u0056\u0049\u0050\u0031\u0030', mg_creator: kc.c, mg_source: 'popup' } : { mg_offer: '\u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035', mg_source: 'popup' };
        var kHead = { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' };
        var kUrl = 'https://a.klaviyo.com/client/';
        try {
          fetch(kUrl + 'profiles?company_id=THFumQ', { method: 'POST', keepalive: true, headers: kHead, body: JSON.stringify({ data: { type: 'profile', attributes: { email: em, properties: props } } }) }).catch(function () {});
          fetch(kUrl + 'subscriptions?company_id=THFumQ', { method: 'POST', keepalive: true, headers: kHead, body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Mozes Gallery popup', profile: { data: { type: 'profile', attributes: { email: em, properties: props } } } }, relationships: { list: { data: { type: 'list', id: 'Y884Lp' } } } } }) }).catch(function () {});
        } catch (e) {}
      });
    }

    /* 6s. 30.10: the footer sign-up goes through the sign-up box, so it shows the code right away and the email reaches
       Klaviyo's welcome flow with the right offer; the footer form alone did neither */
    if (kForm) {
      document.querySelectorAll('form').forEach(function (fForm) {
        if (fForm.mgRoute || fForm.closest('#mgPop') || !fForm.querySelector('input[name="form_type"][value="customer"]') || !fForm.querySelector('input[type=email]')) return;
        fForm.mgRoute = 1;
        fForm.addEventListener('submit', function (e) {
          var em = (fForm.querySelector('input[type=email]').value || '').trim(), kIn = kForm.querySelector('input[type=email]');
          if (!kIn || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          kIn.value = em;
          if (kForm.requestSubmit) kForm.requestSubmit(); else kForm.submit();
        }, true);
      });
    }

    /* 6t. 30.10, the checkout leak: the sign-up box covered the whole phone screen right as a visitor tapped "הוספה לסל", and swallowed
       the tap. It never opens over a tap on a buy button now, and once something is in the bag it no longer opens by itself (the bag
       offers it, 6u); a desktop exit and a tap on the gift button still open it */
    var gPop = document.getElementById('mgPop');
    var gDesc = Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'hidden');
    if (gPop && !gPop.mgGuard && gDesc && gDesc.set) {
      gPop.mgGuard = 1;
      var gTap = 0, gBuy = 0;
      var gBuySel = 'button[name="add"], .add-to-cart-button, .mg-cp__btn, button[name="checkout"], .mg-cart-sticky__btn, .mg-sticky__b, .shopify-payment-button, .quick-add__submit, [data-mg-quick-add]';
      var gAdded = function () { try { return sessionStorage.getItem('mgAdded') === '1'; } catch (e) { return false; } };
      document.addEventListener('pointerdown', function (e) {
        gTap = Date.now();
        if (e.target.closest && e.target.closest(gBuySel)) { gBuy = gTap; try { sessionStorage.setItem('mgAdded', '1'); } catch (er) {} }
      }, true);
      Object.defineProperty(gPop, 'hidden', {
        configurable: true,
        get: function () { return gDesc.get.call(gPop); },
        set: function (v) {
          /* the fast-pay offer (6w) opens the box on purpose, right after a tap on a buy button */
          if (!v && window.mgPopForce) { window.mgPopForce = false; gDesc.set.call(gPop, v); return; }
          if (!v) {
            var now = Date.now(), ev = window.event;
            var byItself = now - gTap > 1500 && !(ev && ev.type === 'mouseout');
            if (now - gBuy < 1500 || (byItself && gAdded())) {
              var gT = document.getElementById('mgTeaser'), gJoined = false;
              try { gJoined = localStorage.getItem('mgPopDone') === '1'; } catch (e) {}
              if (gT && !gJoined) gT.hidden = false;
              return;
            }
          }
          gDesc.set.call(gPop, v);
        }
      });
    }

    /* 6u. the bag: a visitor who has not joined yet is shown how to get the first-order 25% before paying (a creator's visitor: the
       extra 10%), instead of meeting the full price at checkout */
    var uJoined = false;
    try { uJoined = localStorage.getItem('mgPopDone') === '1'; } catch (e) {}
    var uCart = /\/cart\/?$/.test(location.pathname) && !uJoined && gPop;
    /* the bag re-draws itself when a quantity changes, so the box is put back after each re-draw */
    var uRun = function () {
      var uPay = document.querySelector('main button[name="checkout"]');
      if (!uPay || document.querySelector('.mg-cart-join')) return;
      var uVip = document.documentElement.classList.contains('mg-creator'), uCode = '';
      try { uCode = (JSON.parse(localStorage.getItem('mgCreatorCode') || 'null') || {}).c || ''; } catch (e) {}
      var uBox = document.createElement('div');
      uBox.className = 'mg-cart-join';
      uBox.style.cssText = 'margin:0 0 14px;padding:14px 16px;border:1px solid #c9a86a;border-radius:14px;background:rgba(201,168,106,.1);text-align:center;line-height:1.5';
      uBox.innerHTML = (uVip && uCode
        ? '<b style="display:block;font-size:17px">🎁 עוד 10% הנחה על ההזמנה הזו</b><span style="display:block;font-size:14px;margin:4px 0 10px">בנוסף לקוד ' + uCode + '. משאירים מייל, וההנחה נכנסת לסל לבד.</span>'
        : '<b style="display:block;font-size:17px">🎁 25% הנחה על ההזמנה הזו</b><span style="display:block;font-size:14px;margin:4px 0 10px">משאירים מייל, וההנחה נכנסת לסל לבד. לא צריך להקליד קוד בקופה.</span>') +
        '<button type="button" style="width:100%;padding:12px 16px;border:0;border-radius:999px;background:#c9a86a;color:#1b1712;font-weight:700;font-size:16px;cursor:pointer">' + (uVip && uCode ? 'אני רוצה עוד 10%' : 'אני רוצה 25% הנחה') + '</button>';
      uBox.querySelector('button').addEventListener('click', function () { if (window.mgOpenPop) window.mgOpenPop(); });
      uPay.insertAdjacentElement('beforebegin', uBox);
    };
    if (uCart) {
      uRun();
      var uT = 0, uMain = document.querySelector('main');
      if (uMain) new MutationObserver(function () { if (!uT) uT = setTimeout(function () { uT = 0; uRun(); }, 300); }).observe(uMain, { childList: true, subtree: true });
    }

    /* 6v. right after the sign-up the 25% goes into the bag by itself, so nobody has to type the code at checkout; in the bag the
       page reloads once the box is closed, to show the lower total */
    if (!document.documentElement.classList.contains('mg-creator') && document.querySelector('#mgPop [data-mg-success]')) {
      try {
        if (!sessionStorage.getItem('mgW25On')) {
          sessionStorage.setItem('mgW25On', '1');
          fetch('/discount/\u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035?redirect=%2Fcart.js', { credentials: 'same-origin' }).then(function () {
            /* a sign-up that started from "לתשלום מהיר" (6w) already put the piece in the bag: closing the box goes on to checkout */
            var vPay = false;
            try { vPay = sessionStorage.getItem('mgFastGo') === '1'; sessionStorage.removeItem('mgFastGo'); } catch (e) {}
            if (!gPop || (!vPay && !/\/cart\/?$/.test(location.pathname))) return;
            if (vPay) gPop.querySelectorAll('[data-mg-close]').forEach(function (c) { if (c.textContent.trim().length > 2) c.textContent = 'להמשך לתשלום עם ההנחה ←'; });
            gPop.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-mg-close], #mgPopCopy')) setTimeout(function () { if (vPay) location.href = '/checkout'; else location.reload(); }, 950); });
          }).catch(function () {});
        }
      } catch (e) {}
    }

    /* 6w. 30.10: "לתשלום מהיר" on a product page went straight to checkout, past the bag's offer (6u), so a visitor who had not
       joined paid the full price there. Its first tap now shows the sign-up box once: "לא עכשיו" carries on to checkout as before,
       and a sign-up first puts the piece in the bag, so once the code shows the visitor goes on to checkout with the 25% (6v) */
    var wForm = null, wJoined = false;
    try { wJoined = localStorage.getItem('mgPopDone') === '1'; } catch (e) {}
    var wGo = function () {
      var f = wForm;
      wForm = null;
      if (!f) return;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: new FormData(f) })
        .then(function (r) { location.href = r.ok ? '/checkout' : '/cart'; })
        .catch(function () { location.href = '/cart'; });
    };
    if (gPop && kForm && !wJoined && !document.documentElement.classList.contains('mg-creator')) {
      document.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.mg-cp__btn');
        if (!b || !e.isTrusted || !window.mgOpenPop) return;
        try { if (sessionStorage.getItem('mgFastOffer')) return; sessionStorage.setItem('mgFastOffer', '1'); } catch (er) { return; }
        var wBox = b.closest('.mg-cp');
        var f = b.closest('form') || (wBox && wBox.parentNode.closest('form')) || document.querySelector('form[action*="/cart/add"][data-mg-cp-done]');
        if (!f) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        wForm = f;
        gPop.querySelectorAll('[data-mg-close]').forEach(function (c) { if (c.textContent.trim().length > 2) c.textContent = 'לא תודה, להמשיך לתשלום'; });
        window.mgPopForce = true;
        window.mgOpenPop();
      }, true);
      gPop.addEventListener('click', function (e) { if (wForm && e.target.closest && e.target.closest('[data-mg-close]')) setTimeout(wGo, 50); });
      document.addEventListener('keydown', function (e) { if (wForm && e.key === 'Escape') setTimeout(wGo, 50); });
      kForm.addEventListener('submit', function () {
        if (!wForm) return;
        try { sessionStorage.setItem('mgFastGo', '1'); } catch (e) {}
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', keepalive: true, body: new FormData(wForm) }).catch(function () {});
        wForm = null;
      }, true);
    }
    } catch (e) {}

    /* 6g. 25.10 (owner's request): \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035 is earned with the email sign-up, so a visitor who has not joined never sees it.
       A creator's visitor is offered 10% more (\u0056\u0049\u0050\u0031\u0030) for the sign-up, on top of the creator's code. */
    (function () {
      var de = document.documentElement;
      var get = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
      var saved = null;
      try { saved = JSON.parse(get('mgCreatorCode') || 'null'); } catch (e) {}
      var creator = de.classList.contains('mg-creator') && saved && saved.c ? saved.c : '';
      var joined = get('mgPopDone') === '1';
      if (!creator && joined) return;
      var pop = document.getElementById('mgPop'), teaser = document.getElementById('mgTeaser');
      var openPop = function () { if (!pop) return; pop.hidden = false; if (teaser) teaser.hidden = true; };
      var setText = function (el, t) { if (el && el.textContent !== t) el.textContent = t; };
      var swap = function (root, skip, list) {
        var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
        while ((n = w.nextNode())) if (/\u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035/.test(n.nodeValue) && !(skip && n.parentElement && n.parentElement.closest(skip))) hits.push(n);
        hits.forEach(function (t) { var v = t.nodeValue; list.forEach(function (r) { v = v.replace(r[0], r[1]); }); if (v !== t.nodeValue) t.nodeValue = v; });
      };
      /* the landing page's copy button copies \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035 whatever it says: give it a clean one */
      var copyBtn = function (label, fn) {
        var b = document.querySelector('.mgfl [data-mgfl-copy]');
        if (!b || b.mgDone) return;
        var nb = b.cloneNode(false);
        nb.mgDone = 1;
        nb.textContent = label;
        nb.addEventListener('click', function () { fn(nb); });
        b.replaceWith(nb);
      };

      if (creator) {
        var P = /(\d{1,2})$/.test(creator) ? +RegExp.$1 : 15;
        if (P < 5 || P > 50) P = 15;
        de.classList.add('mg-vip');
        /* the creator text swap in the header empties window.mgOpenPop on every pass; keep a working one */
        try { Object.defineProperty(window, 'mgOpenPop', { configurable: true, get: function () { return openPop; }, set: function () {} }); } catch (e) {}
        var bar = '🎉 בלאק פריידיי וחנוכה עד 12.12: ' + P + '% עם הקוד ' + creator + ' ועוד 10% בהרשמה עם המייל';
        var vip = function () {
          /* compare whole lines: another script wraps the percentages in spans, so a single text node never equals the line */
          document.querySelectorAll('.announcement-bar').forEach(function (ab) {
            var w = document.createTreeWalker(ab, NodeFilter.SHOW_TEXT, null), n, lines = [];
            while ((n = w.nextNode())) if (/בלאק פריידיי/.test(n.nodeValue) && lines.indexOf(n.parentElement) === -1) lines.push(n.parentElement);
            lines.forEach(function (el) { if (el.textContent.trim() !== bar) el.textContent = bar; });
          });
          if (teaser) { setText(teaser, '🎁 עוד 10% הנחה'); teaser.setAttribute('aria-label', 'פתיחת הטבה של 10% הנחה נוספת'); }
          /* the footer sign-up line offers the box's 10% too: the header's swap turned its "25% הנחה להזמנה הראשונה" into the creator's
             15%, which read as 15% for joining */
          document.querySelectorAll('.shopify-section-group-footer-group p').forEach(function (fp) {
            if (fp.mgVip || fp.closest('#mgPop') || !/להזמנה הראשונה/.test(fp.textContent)) return;
            fp.mgVip = 1;
            fp.innerHTML = 'הירשמו וקבלו <strong>10% הנחה נוספת</strong>, בנוסף ל-' + P + '% מהקוד ' + creator + ', וגישה ראשונה לקולקציות חדשות ולמבצעים.';
          });
          if (!pop) return;
          setText(pop.querySelector('.mg-pop__eyebrow'), 'בנוסף לקוד ' + creator);
          var t = pop.querySelector('.mg-pop__t');
          if (t && !t.mgVip) { t.mgVip = 1; t.innerHTML = '<span class="mg-pop__big">10%</span> הנחה נוספת'; }
          var x = pop.querySelector('.mg-pop__txt');
          if (x && !x.mgVip) { x.mgVip = 1; x.innerHTML = 'השאירו מייל וקבלו מיד קוד ל-<strong>10% הנחה נוספת</strong>, שמצטרפת ל-' + P + '% מהקוד ' + creator + '. עם 2–3 תכשיטים: עד 36% הנחה.'; }
          setText(pop.querySelector('.mg-pop__btn'), 'אני רוצה עוד 10%');
          /* after the sign-up the box shows the code: \u0056\u0049\u0050\u0031\u0030, not \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035 */
          swap(pop, null, [[/\u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035/g, '\u0056\u0049\u0050\u0031\u0030']]);
          var w2 = document.createTreeWalker(pop, NodeFilter.SHOW_TEXT, null), m;
          while ((m = w2.nextNode())) if (/25%/.test(m.nodeValue)) m.nodeValue = m.nodeValue.replace(/25%/g, '10%');
        };
        vip();
        document.addEventListener('click', function (e) {
          var c = e.target.closest && e.target.closest('#mgPopCopy');
          if (!c) return;
          e.stopPropagation();
          try { navigator.clipboard.writeText('\u0056\u0049\u0050\u0031\u0030'); } catch (er) {}
          c.textContent = 'הקוד הועתק ✓';
          setTimeout(function () { if (pop) pop.hidden = true; }, 900);
        }, true);
        /* right after the sign-up both codes go into the cart together (they are set to combine in Shopify) */
        if (pop && pop.querySelector('[data-mg-success]')) {
          try {
            if (!sessionStorage.getItem('mgVipOn')) {
              sessionStorage.setItem('mgVipOn', '1');
              fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: creator + ',\u0056\u0049\u0050\u0031\u0030' }) }).catch(function () {});
            }
          } catch (e) {}
        }
        copyBtn('העתקת הקוד ' + creator, function (b) {
          var done = function () { b.textContent = '✓ הקוד ' + creator + ' הועתק'; };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(creator).then(done, done); else done();
        });
        var vt = 0;
        new MutationObserver(function () { if (!vt) vt = setTimeout(function () { vt = 0; vip(); }, 300); }).observe(document.body, { childList: true, subtree: true });
        return;
      }

      /* a visitor who has not joined yet: every mention of the code becomes the way to get it */
      de.classList.add('mg-gate');
      var RULES = document.documentElement.lang === 'en' ? [[/(with )?(the )?code WELCOME25/gi, 'when you join by email'], [/WELCOME25/g, 'the welcome code']] : [[/עם הקוד \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035/g, 'בהרשמה עם המייל'], [/את הקוד \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035/g, 'קוד הנחה במייל'], [/הקוד \u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035/g, 'קוד ההצטרפות'], [/\u0057\u0045\u004C\u0043\u004F\u004D\u0045\u0032\u0035/g, 'קוד ההצטרפות']];
      var join = function () { if (window.mgOpenPop) window.mgOpenPop(); };
      var gate = function () {
        swap(document.body, '#mgPop, .mg-launch, [class*="cart-discount"], .cart-discounts, script, style', RULES);
        /* product pages: the launch line keeps the member price and asks for the email instead of naming the code */
        document.querySelectorAll('.mg-launch:not(.mg-join)').forEach(function (l) {
          var price = l.querySelector('b');
          if (!price) return;
          var nx = l.nextElementSibling;
          if (!nx || !nx.classList.contains('mg-join')) {
            nx = document.createElement('div');
            nx.className = 'mg-launch mg-join';
            nx.setAttribute('role', 'button');
            nx.tabIndex = 0;
            nx.addEventListener('click', join);
            nx.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); join(); } });
            l.insertAdjacentElement('afterend', nx);
          }
          var h = '🖤 בלאק פריידיי וחנוכה עד 12.12: <b>' + price.textContent + '</b> בהרשמה עם המייל<small>25% הנחה על ההזמנה הראשונה · לקבלת הקוד</small>';
          if (nx.innerHTML !== h) nx.innerHTML = h;
        });
      };
      gate();
      copyBtn('לקבלת הקוד במייל', join);
      var gt = 0;
      new MutationObserver(function () { if (!gt) gt = setTimeout(function () { gt = 0; gate(); }, 300); }).observe(document.body, { childList: true, subtree: true });
    })();
  })();
